var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Modal, ModalOverlay } from '@noom/wax-component-library';
import { ErrorView } from './views/ErrorView';
import { WelcomeView } from './views/WelcomeView';
import { InterestSelectView } from './views/InterestSelectView';
import { CommunitySelectView } from './views/CommunitySelectView';
export var OnboardingStep;
(function (OnboardingStep) {
    OnboardingStep[OnboardingStep["welcome"] = 0] = "welcome";
    OnboardingStep[OnboardingStep["interests"] = 1] = "interests";
    OnboardingStep[OnboardingStep["communities"] = 2] = "communities";
})(OnboardingStep || (OnboardingStep = {}));
function OnboardingContent({ step, error, isLoading, interests, communities, onSubmit, onCancel, onReset, onSubmitInterests, onSubmitCommunities, fireworksImageUrl, }) {
    if (error) {
        return React.createElement(ErrorView, { onCancel: onCancel, onReset: onReset, error: error });
    }
    if (step === OnboardingStep.welcome)
        return (React.createElement(WelcomeView, { isLoading: isLoading, onSubmit: onSubmit, fireworksImageUrl: fireworksImageUrl }));
    if (step === OnboardingStep.interests)
        return (React.createElement(InterestSelectView, { interests: interests, isLoading: isLoading, onSubmit: onSubmitInterests }));
    if (step === OnboardingStep.communities)
        return (React.createElement(CommunitySelectView, { communities: communities, isLoading: isLoading, onSubmit: onSubmitCommunities }));
    return null;
}
export function OnboardingModal(_a) {
    var { error, step = OnboardingStep.welcome, isLoading, onReset, onCancel, onSubmit, onSubmitInterests, onSubmitCommunities, interests, communities, fireworksImageUrl } = _a, props = __rest(_a, ["error", "step", "isLoading", "onReset", "onCancel", "onSubmit", "onSubmitInterests", "onSubmitCommunities", "interests", "communities", "fireworksImageUrl"]);
    return (React.createElement(Modal, Object.assign({}, props, { motionPreset: "none", scrollBehavior: "inside" }),
        React.createElement(ModalOverlay, null),
        React.createElement(OnboardingContent, { step: step, error: error, isLoading: isLoading, interests: interests, communities: communities, onSubmit: onSubmit, onCancel: onCancel, onReset: onReset, onSubmitInterests: onSubmitInterests, onSubmitCommunities: onSubmitCommunities, fireworksImageUrl: fireworksImageUrl })));
}
//# sourceMappingURL=OnboardingModal.js.map